/* ============================================================
   CDS Product Page — utilitaires pour blocs natifs custom
   ============================================================
   Extrait du fichier section pour reduire sa taille en-dessous
   de la limite Shopify de 256 Ko.

   API publique : window.CDSPpBlocks
     - hideEmptyWrappers(S)   : scan .cds-pp__info > * et masque les vides
     - initMeasurements(S)    : wire le bloc Mesures (tag "mesure")
     - initShapePicker(S)     : wire le bloc Selecteur de forme (tag "forme")

   Toutes les fonctions prennent S = document.getElementById('cds-pp-XXX')
   comme parametre. Elles peuvent etre appelees plusieurs fois sans
   re-bind les events (idempotent).
============================================================ */
(function() {

  /* Selecteurs de blocs purement visuels (separateurs, dividers, etc.) qu'on
     doit conserver meme s'ils n'ont ni texte ni input. Ils ont du rendu CSS
     (border/background) sans contenu HTML. */
  var VISUAL_ONLY_SELECTOR = '.cds-pp__sep, .cds-pp__separator, .cds-pp__divider, .cds-pp__shipping-bar, hr';

  function hideEmptyWrappers(S) {
    var info = S.querySelector('.cds-pp__info');
    if (!info) return;
    var children = info.children;
    for (var i = 0; i < children.length; i++) {
      var wrap = children[i];
      if (wrap.classList.contains('is-block-empty')) wrap.classList.remove('is-block-empty');
      /* Wrapper completement vide (no children + no text) -> hide */
      if (!wrap.children.length && !(wrap.textContent || '').trim()) {
        wrap.classList.add('is-block-empty');
        continue;
      }
      /* Whitelist : si le wrapper contient un element "visuel" (sep, hr, etc.), on garde */
      if (wrap.querySelector(VISUAL_ONLY_SELECTOR)) continue;
      var hasMeaningfulContent = false;
      var descendants = wrap.querySelectorAll('*');
      for (var j = 0; j < descendants.length; j++) {
        var d = descendants[j];
        var tag = d.tagName;
        if (tag === 'IMG' || tag === 'INPUT' || tag === 'BUTTON' || tag === 'SELECT' || tag === 'TEXTAREA' || tag === 'SVG' || tag === 'svg' || tag === 'HR') {
          var st = window.getComputedStyle(d);
          if (st.display !== 'none' && st.visibility !== 'hidden') { hasMeaningfulContent = true; break; }
        }
        if (d.children.length === 0) {
          var txt = (d.textContent || '').trim();
          if (txt) {
            var s = window.getComputedStyle(d);
            if (s.display !== 'none' && s.visibility !== 'hidden') { hasMeaningfulContent = true; break; }
          }
        }
      }
      if (!hasMeaningfulContent) wrap.classList.add('is-block-empty');
    }
  }

  function initMeasurements(S) {
    var mf = S.querySelector('[data-pp-mf]');
    if (!mf || mf._mcInit) return;
    var M = window.MrCandyMeasurements;
    if (!M) {
      var retry = function() { initMeasurements(S); };
      document.addEventListener('DOMContentLoaded', retry);
      window.addEventListener('load', retry);
      return;
    }
    mf._mcInit = true;

    /* === Toggle question "Tu connais tes mesures ? Oui/Non" (workflow sizing kit) ===
       Defaut "no" (Non) : champs caches + bloc save masque + property _needs_kit=true → auto-add kit
       Mode "yes" (Oui)  : champs visibles + bloc save visible + _needs_kit=false. */
    var hasToggleInputs = mf.querySelectorAll('[data-pp-mf-has]');
    var toggleHint = mf.querySelector('[data-pp-mf-toggle-hint]');
    var mfFields = mf.querySelector('[data-pp-mf-fields]');
    var needsKitInput = mf.querySelector('[data-pp-mf-needs-kit]');
    /* Bloc save profiles (cds-measurements-product-display) : masque quand "Non"
       car la cliente n'a rien a enregistrer si elle n'a pas ses mesures. */
    var mcDisplay = document.querySelector('[data-mc-display]');
    var mfRequired = mf.querySelector('[data-pp-mf]') ? false : false; /* set par bloc settings, lu plus tard */
    function applyHasToggle(value) {
      var hasMeasurements = (value === 'yes');
      hasToggleInputs.forEach(function(inp) {
        var pill = inp.closest('.cds-pp__mf-toggle-pill');
        if (pill) pill.classList.toggle('is-active', inp.value === value);
      });
      if (mfFields) {
        if (hasMeasurements) mfFields.removeAttribute('hidden');
        else mfFields.setAttribute('hidden', '');
        /* CRUCIAL : disable TOUS les inputs/select dans le wrapper quand "Non".
           Les inputs disabled ne sont PAS inclus dans le FormData submit.
           Sans ça, le hidden "Unité de mesure: Millimètres" (qui utilise
           form="..." pour s'attacher au form parent) s'envoie quand même
           et apparait dans le panier sur le produit "Non, je n'ai pas mes mesures". */
        var fieldsControls = mfFields.querySelectorAll('input, select, textarea');
        fieldsControls.forEach(function(ctrl) {
          ctrl.disabled = !hasMeasurements;
        });
      }
      /* Bloc save profiles : visible UNIQUEMENT si la cliente a ses mesures
         (sinon rien a enregistrer → on retire pour ne pas l'embrouiller). */
      if (mcDisplay) {
        if (hasMeasurements) mcDisplay.removeAttribute('hidden');
        else mcDisplay.setAttribute('hidden', '');
      }
      /* Property _needs_kit : true si elle n'a PAS ses mesures (= besoin du kit) */
      if (needsKitInput) needsKitInput.value = hasMeasurements ? 'false' : 'true';
      /* Required sur les inputs : seulement si bloc settings.required ET toggle "yes" */
      var blockRequired = mf.getAttribute('data-mf-required') === 'true';
      mf.querySelectorAll('[data-pp-mf-input]').forEach(function(inp) {
        if (blockRequired && hasMeasurements) inp.setAttribute('required', '');
        else inp.removeAttribute('required');
      });
      /* Hide le hint banner quand "Oui" (plus de kit a ajouter, message inutile) */
      if (toggleHint) {
        if (hasMeasurements) toggleHint.setAttribute('hidden', '');
        else toggleHint.removeAttribute('hidden');
      }
    }
    if (hasToggleInputs.length) {
      hasToggleInputs.forEach(function(inp) {
        inp.addEventListener('change', function() { applyHasToggle(inp.value); });
      });
      /* Init : applique l'etat coche par defaut */
      var checked = mf.querySelector('[data-pp-mf-has]:checked');
      applyHasToggle(checked ? checked.value : 'no');
    }

    var loadWrap = mf.querySelector('[data-pp-mf-load]');
    var loadBtn  = mf.querySelector('[data-pp-mf-load-btn]');
    var loadList = mf.querySelector('[data-pp-mf-load-list]');
    var unitInputs = mf.querySelectorAll('[data-mc-unit]');
    var unitHints  = mf.querySelectorAll('[data-mc-unit-hint]');
    var unitProperty = mf.querySelector('[data-pp-mf-unit-property]');
    var helpMm = mf.querySelector('[data-mc-help-mm]');
    var helpKit = mf.querySelector('[data-mc-help-kit]');

    function getUnit() {
      for (var i = 0; i < unitInputs.length; i++) if (unitInputs[i].checked) return unitInputs[i].value;
      return 'mm';
    }
    function setUnit(unit) {
      unit = unit || 'mm';
      var hint = unit === 'kit' ? '(sizing kit)' : '(en mm)';
      unitInputs.forEach(function(inp) {
        var match = inp.value === unit;
        inp.checked = match;
        var pill = inp.closest('.cds-mc-unit__pill');
        if (pill) pill.classList.toggle('is-active', match);
      });
      unitHints.forEach(function(el) { el.textContent = hint; });
      if (unitProperty) unitProperty.value = unit === 'kit' ? 'Sizing kit' : 'Millimètres';
      /* Bascule le texte d'aide selon l'unite (les 2 versions sont rendues
         dans le HTML, on toggle leur visibilite) */
      if (helpMm) helpMm.hidden = (unit === 'kit');
      if (helpKit) helpKit.hidden = (unit !== 'kit');
    }
    unitInputs.forEach(function(inp) {
      inp.addEventListener('change', function() { setUnit(inp.value); });
    });

    function refresh() {
      var profiles = M.listProfiles();
      if (!loadWrap) return;
      if (profiles.length === 0) { loadWrap.setAttribute('hidden', ''); return; }
      loadWrap.removeAttribute('hidden');
    }

    function fillFromProfile(profile) {
      mf.querySelectorAll('[data-pp-mf-input]').forEach(function(inp) {
        var side = inp.getAttribute('data-mf-side');
        var finger = inp.getAttribute('data-mf-finger');
        var v = profile.hands && profile.hands[side] && profile.hands[side][finger];
        if (v != null) inp.value = String(v);
      });
      /* Sync l'unite avec celle du profil charge */
      if (profile.unit) setUnit(profile.unit);
      if (loadList) { loadList.innerHTML = ''; loadList.setAttribute('hidden', ''); }
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var profiles = M.listProfiles();
        if (profiles.length === 0) return;
        if (profiles.length === 1) { fillFromProfile(profiles[0]); return; }
        if (!loadList) return;
        var html = '';
        profiles.forEach(function(p) {
          var label = M.profileLabel(p.shape, p.length);
          var unit = M.unitBadge(p.unit || 'mm');
          html += '<button type="button" class="cds-pp__mf-load-item" data-mf-load-key="' + p.key.replace(/"/g, '&quot;') + '">'
            + '<strong>' + label + '</strong>'
            + '<span class="cds-pp__mf-load-item-meta">' + unit + '</span>'
            + '</button>';
        });
        loadList.innerHTML = html;
        loadList.removeAttribute('hidden');
      });
    }

    if (loadList) {
      loadList.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-mf-load-key]');
        if (!btn) return;
        var key = btn.getAttribute('data-mf-load-key');
        var profiles = M.listProfiles();
        var profile = null;
        for (var i = 0; i < profiles.length; i++) if (profiles[i].key === key) { profile = profiles[i]; break; }
        if (profile) fillFromProfile(profile);
      });
    }

    refresh();
    window.addEventListener('mrcandy:measurements:saved', refresh);
    window.addEventListener('mrcandy:measurements:cleared', refresh);
  }

  function initShapePicker(S) {
    var sp = S.querySelector('[data-pp-sp]');
    if (!sp || sp._mcInit) return;
    sp._mcInit = true;
    var trigger = sp.querySelector('[data-pp-sp-trigger]');
    var modal   = sp.querySelector('[data-pp-sp-modal]');
    var triggerCurrent = sp.querySelector('[data-pp-sp-trigger-current]');
    var triggerImage   = sp.querySelector('[data-pp-sp-trigger-image]');
    var propertyInput  = sp.querySelector('[data-pp-sp-property-input]');
    if (!trigger || !modal) return;

    function openModal() {
      modal.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }

    function updateTriggerDisplay(name, imgSrc) {
      if (triggerCurrent) triggerCurrent.textContent = name || '';
      if (triggerImage) {
        triggerImage.innerHTML = imgSrc ? '<img src="' + imgSrc + '" alt="">' : '💅';
      }
    }

    function selectShape(card) {
      var name = card.getAttribute('data-shape-name') || (card.querySelector('.cds-pp__sp-card-name') || {}).textContent || '';
      var img  = (card.querySelector('.cds-pp__sp-card-img') || {}).src || '';
      /* Stocke la valeur dans le hidden input -> sera envoye en line item property au add to cart */
      if (propertyInput) propertyInput.value = name;
      sp.querySelectorAll('[data-pp-sp-option]').forEach(function(c) { c.classList.remove('is-active'); });
      card.classList.add('is-active');
      updateTriggerDisplay(name, img);
    }

    trigger.addEventListener('click', openModal);
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-pp-sp-close]')) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    /* ─── Modal 2 (longueur conditionnelle) ─── */
    var lp2Trigger = sp.querySelector('[data-pp-lp2-trigger]');
    var lp2Modal = sp.querySelector('[data-pp-lp2-modal]');
    var lp2Pills = lp2Modal ? lp2Modal.querySelectorAll('[data-pp-lp2-option]') : [];
    var lp2Property = sp.querySelector('[data-pp-lp2-property-input]');
    var lp2TriggerCurrent = sp.querySelector('[data-pp-lp2-trigger-current]');
    var lp2HasModal = lp2Modal && lp2Pills.length > 0;
    var currentShapeLengths = '';
    var currentLength = '';

    function openLp2() {
      if (!lp2Modal) return;
      lp2Modal.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeLp2() {
      if (!lp2Modal) return;
      lp2Modal.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
    }

    /* Filtre les pills selon currentShapeLengths. Retourne la 1ere visible. */
    function refreshLp2Pills() {
      var available = currentShapeLengths.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      var firstVisible = null;
      lp2Pills.forEach(function(pill) {
        var name = pill.getAttribute('data-length-name');
        if (available.indexOf(name) !== -1) {
          pill.removeAttribute('hidden');
          if (!firstVisible) firstVisible = pill;
        } else {
          pill.setAttribute('hidden', '');
          pill.classList.remove('is-active');
        }
      });
      /* Si la longueur courante n'est plus dispo : reset */
      if (currentLength && available.indexOf(currentLength) === -1) {
        currentLength = '';
        if (lp2Property) lp2Property.value = '';
        if (lp2TriggerCurrent) lp2TriggerCurrent.textContent = '';
      }
      return firstVisible;
    }

    function selectLength(pill) {
      lp2Pills.forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      var name = pill.getAttribute('data-length-name') || '';
      currentLength = name;
      if (lp2Property) lp2Property.value = name;
      if (lp2TriggerCurrent) lp2TriggerCurrent.textContent = name;
    }

    if (lp2HasModal) {
      lp2Pills.forEach(function(pill) {
        pill.addEventListener('click', function(e) {
          e.preventDefault();
          selectLength(pill);
          closeLp2();
        });
      });
      lp2Modal.addEventListener('click', function(e) {
        if (e.target.closest('[data-pp-lp2-close]')) closeLp2();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !lp2Modal.hasAttribute('hidden')) closeLp2();
      });
      if (lp2Trigger) {
        lp2Trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (lp2Trigger.disabled) return;
          refreshLp2Pills();
          openLp2();
        });
      }
    }

    sp.querySelectorAll('[data-pp-sp-option]').forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        selectShape(card);
        closeModal();
        /* Hook modal 2 : update lengths dispos + auto-chainage */
        if (lp2HasModal) {
          currentShapeLengths = card.getAttribute('data-shape-lengths') || '';
          var firstVisible = refreshLp2Pills();
          if (firstVisible) {
            if (lp2Trigger) {
              lp2Trigger.disabled = false;
              lp2Trigger.removeAttribute('aria-disabled');
            }
            /* Auto-chainage : si pas de longueur courante valide → ouvrir modal 2 */
            if (!currentLength) {
              setTimeout(openLp2, 250);
            }
          } else {
            /* Forme sans longueurs dispo → desactive bouton 2 + reset */
            if (lp2Trigger) {
              lp2Trigger.disabled = true;
              lp2Trigger.setAttribute('aria-disabled', 'true');
            }
            if (lp2Property) lp2Property.value = '';
            if (lp2TriggerCurrent) lp2TriggerCurrent.textContent = '';
          }
        }
        /* Clear visuel d'erreur sur le bouton shape (s'il y en avait) */
        trigger.classList.remove('is-invalid');
      });
    });

    /* ─── Validation au click sur le bouton ATC ───
       HTML5 'required' sur input[type=hidden] est ignore par le navigateur, et
       le form du theme intercepte le submit pour faire un AJAX add-to-cart
       (ouvre le drawer). On intercepte donc le CLICK du bouton ATC en mode
       CAPTURE (avant tout autre listener) + stopImmediatePropagation pour
       empecher l'AJAX.

       On valide aussi les inputs mesures [data-pp-mf-input][required] car le
       form du theme ne les valide pas (il ne valide que [data-cf-input]). */
    var shapeRequired = propertyInput && propertyInput.getAttribute('data-pp-sp-required') === 'true';
    var lengthRequired = lp2Property && lp2Property.hasAttribute('required');
    var atcBtn = S.querySelector('[data-atc-btn]');
    var stickyAtc = S.querySelector('[data-sticky-atc]');
    function validateAndBlock(e) {
      var missingShape = shapeRequired && (!propertyInput || !propertyInput.value);
      var missingLength = lengthRequired && lp2HasModal && (!lp2Property || !lp2Property.value);
      /* Validation mesures (champs [data-pp-mf-input][required]) */
      var mfInputs = S.querySelectorAll('[data-pp-mf-input][required]');
      var firstInvalidMf = null;
      mfInputs.forEach(function(inp) {
        if (!inp.value || inp.value.trim() === '') {
          inp.style.borderColor = '#d4183d';
          inp.classList.add('is-invalid');
          if (!firstInvalidMf) firstInvalidMf = inp;
        } else {
          inp.style.borderColor = '';
          inp.classList.remove('is-invalid');
        }
      });
      var missingMeasurements = !!firstInvalidMf;
      if (!missingShape && !missingLength && !missingMeasurements) return; /* OK, laisse passer */
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      /* Flash visuel + scroll vers le 1er manquant (priorite forme > longueur > mesures) */
      var target = null;
      if (missingShape) {
        trigger.classList.add('is-invalid');
        target = trigger;
      } else if (missingLength && lp2Trigger) {
        lp2Trigger.classList.add('is-invalid');
        target = lp2Trigger;
      } else if (missingMeasurements) {
        target = firstInvalidMf;
      }
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() {
          trigger.classList.remove('is-invalid');
          if (lp2Trigger) lp2Trigger.classList.remove('is-invalid');
        }, 2500);
      }
    }
    /* Active la validation si AU MOINS un champ est obligatoire (shape, length OU mesures) */
    var hasRequiredMf = S.querySelectorAll('[data-pp-mf-input][required]').length > 0;
    if (shapeRequired || lengthRequired || hasRequiredMf) {
      /* Capture phase = avant tous les autres listeners click + submit */
      if (atcBtn) atcBtn.addEventListener('click', validateAndBlock, true);
      if (stickyAtc) stickyAtc.addEventListener('click', validateAndBlock, true);
      /* Filet de securite : bloque aussi un submit form direct (Enter dans champ) */
      var form = S.querySelector('[data-product-form]');
      if (form) form.addEventListener('submit', validateAndBlock, true);
    }
    /* Clear visuel d'erreur sur les inputs mesures quand l'utilisateur tape */
    S.querySelectorAll('[data-pp-mf-input]').forEach(function(inp) {
      inp.addEventListener('input', function() {
        if (inp.value && inp.value.trim() !== '') {
          inp.style.borderColor = '';
          inp.classList.remove('is-invalid');
        }
      });
    });

    /* Clear visuel d'erreur sur le bouton longueur quand on selectionne */
    if (lp2HasModal) {
      lp2Pills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          if (lp2Trigger) lp2Trigger.classList.remove('is-invalid');
        });
      });
    }
  }

  /* ============================================================
     Bloc Selecteur de longueur (tag "longueur")
     - Style "pills" : toggle .is-active sur le bouton clique +
       pousse la valeur dans l'input hidden rattache au form via form="..."
     - Style "select" : pas besoin de JS (le name="properties[...]" porte
       deja la valeur native du select)
  ============================================================ */
  function initLengthPicker(S) {
    var lp = S.querySelector('[data-pp-lp]');
    if (!lp || lp._mcInit) return;
    lp._mcInit = true;
    /* Pills uniquement : si select, rien a faire */
    if (lp.getAttribute('data-pp-lp-style') === 'select') return;
    var pills = lp.querySelectorAll('[data-pp-lp-pill]');
    var input = lp.querySelector('[data-pp-lp-input]');
    if (!pills.length || !input) return;
    pills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var val = pill.getAttribute('data-lp-value') || '';
        pills.forEach(function(p) {
          var match = (p === pill);
          p.classList.toggle('is-active', match);
          p.setAttribute('aria-checked', match ? 'true' : 'false');
        });
        input.value = val;
        /* Dispatche un input/change pour que d'autres scripts puissent reagir */
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============================================================
     Bloc Champ libre (tag "text")
     - Le champ porte deja name="properties[...]" et form="..."
       donc Shopify capture la valeur tout seul
     - Cote JS : juste maintenir le compteur de caracteres si actif
  ============================================================ */
  function initTextInput(S) {
    /* Plusieurs blocs Champ libre possibles (limit: 3 dans le schema),
       on init chacun separement */
    S.querySelectorAll('.cds-pp__ti').forEach(function(ti) {
      if (ti._mcInit) return;
      ti._mcInit = true;
      var input = ti.querySelector('[data-pp-ti-input]');
      var counter = ti.querySelector('[data-pp-ti-counter]');
      if (!input || !counter) return;
      var max = parseInt(input.getAttribute('maxlength'), 10) || 200;
      var update = function() {
        var len = input.value.length;
        counter.textContent = len + ' / ' + max;
        counter.classList.toggle('is-near-limit', len >= max * 0.9);
      };
      input.addEventListener('input', update);
      update();
    });
  }

  window.CDSPpBlocks = {
    hideEmptyWrappers: hideEmptyWrappers,
    initMeasurements: initMeasurements,
    initShapePicker: initShapePicker,
    initLengthPicker: initLengthPicker,
    initTextInput: initTextInput
  };
})();
